import React from "react";

import { useNavigate, useTranslation } from "utils";

import { Button, Col, Form, Row } from "components";

interface SignupButtonsProps {
  loading: boolean;
  onClick?: () => void;
}

export const SignupButtons: React.FC<SignupButtonsProps> = ({ loading, onClick }) => {
  const { t } = useTranslation("signinup");
  const navigate = useNavigate();

  return (
    <>
      <Row className="center">
        <Col>
          {onClick ? (
            <Button dataTestId="sign-up-button-intro" type="primary" disabled={loading} loading={loading} onClick={onClick}>
              {t("signup.buttons.createAccount")}
            </Button>
          ) : (
            <Form.Item>
              <Button dataTestId="sign-up-button" type="primary" htmlType="submit" disabled={loading} loading={loading}>
                {t("signup.buttons.createAccount")}
              </Button>
            </Form.Item>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            type="secondary"
            mixpanelText={t("signup.buttons.signin")}
            dataTestId="sign-in-button"
            disabled={loading}
            onClick={() => navigate("/sign-in")}
          >
            {t("signup.buttons.signin")}
          </Button>
        </Col>
      </Row>
    </>
  );
};
